export const LocalStorageService = {
    getLoadingUser: function() {
      let status = localStorage.getItem('loading_user')
      if (status == 'true') status = true
      if (status == 'false') status = false
      return status != null  ? status : true;
    },
    setLoadingUser: function(status) {
      localStorage.setItem('loading_user', status);
  },
    getCheckinTickets: function() {
      return JSON.parse(localStorage.getItem('checkin_tickets'));
    },
    setCheckinTickets: function(tickets) {
      localStorage.setItem('checkin_tickets', JSON.stringify(tickets));
    },
    getToken: function() {
      return localStorage.getItem('token');
    },
    setToken: function(token) {
      localStorage.setItem('token', token);
    },
    getUser: function() {
      var user = localStorage.getItem('user')
      if (user) user = JSON.parse(user);
      return user;
    },
    setUser: function(user) {
      localStorage.setItem('user', user ? JSON.stringify(user) : null);
  },
  getTheme: function(userId) {
      if (!userId) return 'light';
      return localStorage.getItem('user_theme_' + userId) === 'dark' ? 'dark' : 'light';
  },
  setTheme: function(userId, theme) {
      if (!userId) return;
      localStorage.setItem('user_theme_' + userId, theme === 'dark' ? 'dark' : 'light');
  },
  getBookingCardsPerRow: function(userId) {
      if (!userId) return 2;
      return Number(localStorage.getItem('user_booking_cards_per_row_' + userId)) === 1 ? 1 : 2;
  },
  setBookingCardsPerRow: function(userId, columns) {
      if (!userId) return;
      localStorage.setItem('user_booking_cards_per_row_' + userId, columns === 1 ? '1' : '2');
  },
  getStates: function () {
      return JSON.parse(localStorage.getItem('states'));
    },
    setStates: function(states) {
      localStorage.setItem('states', JSON.stringify(states));
    },
  }
  